
import { defineComponent, onMounted, reactive, Ref, ref, toRaw } from "vue";
import { PlaySquareOutlined, PlusOutlined } from "@ant-design/icons-vue";
import NavBottom from "@/components/NavBottom.vue";
import { previewCover, provenimg, provenvideo } from "@/utils/common";
import { FromSend, ImgInfo, VideoInfo } from "@/types";
import { uploadflie } from "@/utils/vod";
import { setvideo, videoadd, videodetail } from "@/api";
import { useRoute } from "vue-router";
import { message } from "ant-design-vue";
import { useI18n } from "@/utils/i18n";

export default defineComponent({
    name: "ReleaseWebcast",
    components: {
        PlaySquareOutlined,
        PlusOutlined,
        NavBottom,
    },
    setup() {
        let issum= true;
        const lan: any = useI18n();
        interface FileItem {
            video: Array<string>;
        }
        const fileList: Array<FileItem> = [];

        // 表单数据
        const form = ref<any>({
            title: "",
            img: "",
            fileid: "",
            fileurl: "",
            fileduration: "",
            desc: "",
            video: [""],
        });
        onMounted(async () => {
            if (useRoute().query.id) {
                console.log(useRoute().query.id, "knijkdbj");
                form.value = await videodetail(useRoute().query.id, 1);
                console.log(form.value, "fornm");
            }
        });

        // 是否显示封面预览 封面的路径
        const viewCover: Ref<boolean> = ref(false),
            previewImage: Ref<string> = ref("");
        /**
         * 封面改变触发事件
         */
        function coverChange(info: ImgInfo): void {
            // console.log(info);
            // 获取预览图片
            previewCover(info.file).then((url) => (previewImage.value = url));
            viewCover.value = true;
            // form.cover = fileList;
        }

        /**
         * 上传封面之前的钩子
         * @param file 上传的文件
         */
        const beforeCoverUpload = (file: File): boolean => {
            console.log(file);
            const type = provenimg(file.name);
            if(!type){
                message.error("请重新选择")
            }
            return false;
        };

        /**
         * 删除封面
         */
        function cancelCover(file: number): void {
            console.log(file);
        }
        /**
         * 删除视频列表
         * @param index 删除文件的索引
         */
        function removeFile(index: number): void {
            const newFileList = form.value.video.slice();
            newFileList.splice(index, 1);
            form.value.video = newFileList;
        }

        /**
         * 上传图片
         */
        const uploadpicprogress: Ref<number> = ref(0);
        const videofile = ref<File>();
        const videos = ref<Array<any>>([]);
        const ifalowupload = ref<boolean>(false);
        interface AntUpload {
            action: string;
            data: unknown;
            file: File;
        }
        async function uploadspic(file: AntUpload) {
           
                const res = await uploadflie(file.file, (info: any) => {
                    console.log(info);
                    let jindu: number = info.percent.toFixed(2) * 100;
                    jindu = parseInt(jindu + "");
                    uploadpicprogress.value = jindu || 1;
                });
                console.log(res);
                form.value.img = res.video.url;
            
        }

        function beforeUploadpic(info?: any) {
            console.log(info);
            if (info.type.split("/")[0] != "image") {
                message.error(lan.$t("fengmiangeshi"));
                ifalowupload.value = false;
                return;
            } else {
                ifalowupload.value = true;
            }
        }

        /**
         * 上传视频
         */
        const uploadprogress: Ref<number> = ref(0);
        const ifallowvideo = ref<boolean>(false);
         async function uploads(file: AntUpload) {
                issum = false;
                console.log(file);
                videofile.value = file.file;
                uploadprogress.value = 1;
                videos.value[0].addEventListener("durationchange", () => {
                    console.log(videos.value[0].duration);
                    form.value.fileduration = videos.value[0].duration;
                });
                const res = await uploadflie(file.file, (info: any) => {
                    console.log(info);
                    const jindu = info.percent.toFixed(2) * 100
                    uploadprogress.value = jindu > 0 ? jindu : 1;
                });
                console.log(res);

                form.value.fileid = res.fileId;
                form.value.fileurl = res.video.url;
                issum = true;
        } 

        function beforeVideoUpload(info?: any) {
            console.log(info);
            if (info.type.split("/")[0] != "video") {
                ifallowvideo.value;
                message.error(lan.$t("wenjiangeshi"));
            } else {
                ifallowvideo.value = true;
            }
        }

        /**
         * 表单提交
         */
        const routes = useRoute();
        const onSubmit = async (e: FromSend) => {
            if(!issum){
                message.error(lan.$t("shangchuanwancheng"))
                return; 
            }
            e.preventDefault();
            console.log(toRaw(form.value), 111);
            console.log(toRaw(form.value).video[0].length);

            console.log(routes.query, "adsadsa");
            const subdata = toRaw(form.value);
            if (subdata.title == "") {
                message.error(lan.$t("biaotiweikong"));
                return;
            } else if (subdata.img == "") {
                message.error(lan.$t("fengmianweikong"));
                return;
            } else if (subdata.fileurl == "") {
                message.error(lan.$t("wenjianweikong"));
            } else {
                if (routes.query.id) {
                    form.value.id = routes.query.id;
                    console.log("edi");
                    setvideo(form.value);
                } else {
                    videoadd(form, toRaw(form.value));
                }
                // videoadd(form, toRaw(form.value));
            }

            // videoadd(form, toRaw(form.value));
        };
        function beforeUpload(info?: any) {
            console.log(info);
            if (info.type.split("/")[0] != "video") {
                ifallowvideo.value = false;
                message.error(lan.$t("shipinjieshaoccuowu"));
                return;
            } else {
                ifallowvideo.value = true;
            }
        }
        function video(file: any){
            return provenvideo(file, true)
        }
         function imgs(file: any){
            return provenimg(file)
        }
       

        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            form,
            viewCover,
            previewImage,
            previewCover,
            coverChange,
            cancelCover,
            beforeCoverUpload,
            onSubmit,
            uploadpicprogress,
            uploadspic,
            uploadprogress,
            uploads,
            videofile,
            videos,
            removeFile,
            beforeUpload,
            ifalowupload,
            beforeVideoUpload,
            lan,
            beforeUploadpic,
            video,
            imgs
        };
    },
});
